import React, { useState } from 'react';
import { useAuth } from '../auth';
import { ApleonaLogo } from '../components/ui';

export const Login: React.FC = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email.trim(), password);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Anmeldung fehlgeschlagen');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-visual">
        <div>
          <ApleonaLogo color="#ffffff" />
          <h2>Fuhrpark digital dokumentiert.</h2>
          <p>
            Nutzerwechsel, Poolfahrzeuge und Zustandsprüfungen – mit Fotos, Zeitstempel und
            automatischem Protokollversand.
          </p>
          <ul>
            <li>Übergabe &amp; Rückgabe inkl. Schadensmarkierung</li>
            <li>Poolfahrzeuge statt Papier-Fahrtenbuch</li>
            <li>Wiederkehrende Zustandsdokumentation</li>
            <li>PDF-Protokoll automatisch per E-Mail</li>
          </ul>
        </div>
        <div className="small" style={{ color: 'rgba(186,204,221,.8)' }}>
          Apleona GmbH · An der Gehespitz 50 · 63263 Neu-Isenburg
        </div>
      </div>

      <div className="login-form-wrap">
        <form className="login-form" onSubmit={submit}>
          <h1>Anmelden</h1>
          <p className="lead">Bitte melden Sie sich mit Ihrer Apleona-Kennung an.</p>

          {error ? <div className="alert error">{error}</div> : null}

          <div className="field">
            <label htmlFor="email">E-Mail</label>
            <input
              id="email"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="vorname.nachname@apleona.com"
              required
            />
          </div>
          <div className="field">
            <label htmlFor="pw">Passwort</label>
            <input
              id="pw"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button className="btn primary" style={{ width: '100%', justifyContent: 'center' }} disabled={busy}>
            {busy ? 'Anmeldung läuft …' : 'Anmelden'}
          </button>
        </form>
      </div>
    </div>
  );
};
